/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { PACK_REVALIDATE_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { RevalidatePage } from "@/features/processing/components/revalidate-page";

export const Route = createFileRoute("/_app/packaging/pack-reprint/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(PACK_REVALIDATE_FORM))
      throw redirect({ to: "/packaging/pack-reprint" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <RevalidatePage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
